import { useEffect, useState } from 'react';
import { ACSApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { setBranchesWithUserData } from '../../../store/slices/branch.slice';
import { dispatch } from '../../../store';

const useHttpGetBranchesWithUsersDataOMX = () => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const [isReady, setIsReady] = useState(false);

    const exec = () => {
        const { exec, abort } = acsApi.getOrganizationBranchesWithUsers({
            onSuccess: res => dispatch(setBranchesWithUserData(res.body)),
            onError: error => console.log(error),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    };

    useEffect(exec, []);
    return { isReady, exec };
};

export default useHttpGetBranchesWithUsersDataOMX;
